// extracted by mini-css-extract-plugin
export default {"narrowWindow":"pcVideo_narrowWindow_PyitF","mutedIcon":"pcVideo_mutedIcon_dCjj3"};